module.exports = __webpack_public_path__ + "img/y-253.5d7addf9.png";